module.exports = __webpack_public_path__ + "img/1572112181.e7288293.jpg";